import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { FlexModule } from "@vp/shared/directives/flex";
import { TagManagerActionRowComponent } from "./tag-manager-action-row.component";

@NgModule({
  imports: [CommonModule, MatButtonModule, MatIconModule, MatProgressSpinnerModule, FlexModule],
  declarations: [TagManagerActionRowComponent],
  exports: [TagManagerActionRowComponent]
})
export class TagManagerActionRowModule {}
